import { InputCheckboxProps } from "./InputCheckbox.type";

const INPUT_COLOR_ERROR = "red";
const INPUT_COLOR = "#D0D0D0";

export default function InputCheckbox({
  fieldName,
  label,
  register,
  required,
  error,
  onChange,
  styles,
  defaultChecked,
}: InputCheckboxProps) {
  return (
    <>
      <label>
        <input
          type="checkbox"
          defaultChecked={defaultChecked}
          className={
            !!styles ? styles : "rounded mr-2 text-red-500 focus:ring-red-400"
          }
          {...register(fieldName, {
            required,
            onChange: (e) => {
              onChange && onChange(e);
            },
          })}
        />
        {label}
      </label>
      {/* ERRORS MESSAGE */}
      {error?.message && (
        <span style={{ color: INPUT_COLOR_ERROR }}>{error?.message}</span>
      )}
      {error?.type === "required" && (
        <span style={{ color: INPUT_COLOR_ERROR }}>Seleccion requerida*</span>
      )}
    </>
  );
}
